/**
 * API v1 for FLEXI web portal
 * A sample description of FLEXI API version 1 for web portal.
 *
 * OpenAPI spec version: 1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type PaymentMethodType = 'Undefined' | 'PaymentOrder' | 'BankTransfer' | 'Sipo' | 'PostalOrder' | 'PayAdvance' | 'ExtraAdvance' | 'NextInvoice' | 'PostalOrderA' | 'PostalOrderB' | 'PaymentOrderKredit' | 'PaymentOrderDebit';

export const PaymentMethodType = {
    Undefined: 'Undefined' as PaymentMethodType,
    PaymentOrder: 'PaymentOrder' as PaymentMethodType,
    BankTransfer: 'BankTransfer' as PaymentMethodType,
    Sipo: 'Sipo' as PaymentMethodType,
    PostalOrder: 'PostalOrder' as PaymentMethodType,
    PayAdvance: 'PayAdvance' as PaymentMethodType,
    ExtraAdvance: 'ExtraAdvance' as PaymentMethodType,
    NextInvoice: 'NextInvoice' as PaymentMethodType,
    PostalOrderA: 'PostalOrderA' as PaymentMethodType,
    PostalOrderB: 'PostalOrderB' as PaymentMethodType,
    PaymentOrderKredit: 'PaymentOrderKredit' as PaymentMethodType,
    PaymentOrderDebit: 'PaymentOrderDebit' as PaymentMethodType
};